import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import Link from 'next/link';

import { Button } from '@flipster/react/design-system';
import BoltIcon from '@flipster/react/icon/generated/BoltIcon';
import ChevronRightIcon from '@flipster/react/icon/generated/ChevronRightIcon';
import { css } from '@flipster/styled-system/css';
import { flex, hstack } from '@flipster/styled-system/patterns';

import useStakeFlow from '../useStakeFlow';
import { sparkLaunchpoolItemBunja } from './bunja';

const SparkLaunchpoolItemHeader = () => {
  const { isClosedAtom, isStakableAtom } = useBunja(sparkLaunchpoolItemBunja);
  const isClosed = useAtomValue(isClosedAtom);
  const isStakable = useAtomValue(isStakableAtom);
  const joinSparkLaunchpool = useStakeFlow();
  return (
    <div className={hstack({ justify: 'space-between', mb: 12, color: 'content.default.level-4' })}>
      <TitleArea />
      {!isClosed && (
        <Button
          hierarchy='primary'
          color='accent'
          size='medium'
          label='Join'
          disabled={!isStakable}
          onClick={joinSparkLaunchpool}
          css={css.raw({ w: 78 })}
        />
      )}
    </div>
  );
};

export default SparkLaunchpoolItemHeader;

const TitleArea = () => {
  return (
    <div
      className={css({
        display: 'grid',
        gap: 12,
        gridTemplateColumns: 'max-content minmax(0, max-content)',
        alignItems: 'center',
      })}
    >
      <BoltIcon size={32} />
      <div>
        <Link href='/spark/reward'>
          <div className={flex({ gap: 4, textStyle: 'Title/XS', color: 'content.default.level-5' })}>
            Flipster Sparks
            <ChevronRightIcon size={20} className={css({ color: 'content.default.level-2' })} />
          </div>
        </Link>
        <span className={css({ textStyle: 'Text/S/Regular', color: 'content.default.level-4' })}>
          Redeem a share of the launchpool
        </span>
      </div>
    </div>
  );
};
